var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"retry-attempt"},[_c('AxButton',{attrs:{"type":"submit"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v(" Retry ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }